<script setup lang="ts">
import { useSlots, computed } from 'vue';

import { AppNotification } from '@libs/ui';

interface UnavailableProductLayoutProps {
  description: string;
}
const props = defineProps<UnavailableProductLayoutProps>();

const slots = useSlots();

const hasActions = computed<boolean>(() => !!slots['actions']);
</script>

<template>
  <div class="unavailable-product">
    <AppNotification
      theme="warning"
      :description="{ text: props.description }"
      :icon="{ name: 'infoCircle' }"
      align-center
    >
      <template v-if="hasActions" #actions>
        <slot name="actions" />
      </template>
    </AppNotification>
  </div>
</template>

<style scoped lang="scss">
.unavailable-product {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
